export default ($resource) => {
    const baseUrl = `${SEED_CORE.ENV.API_URL}course/version`;
    const url = `${baseUrl}/:id`;
    return $resource(url, null, {
        update: {
            method: 'PUT',
            url
        },
        deleteTrainingImage: {
            method: 'DELETE',
            url: `${url}/delete-training-image`
        },
        deleteLicence: {
            method: 'DELETE',
            url: `${baseUrl}/delete-licence/:id`
        }
    });
};



// WEBPACK FOOTER //
// ./src/app/resources/CourseVersion/index.js